export enum CircularProgressSize {
  SMALL = 'small',
  LARGE = 'large',
}
